import React, { useState } from 'react';
import { Card, CardBody, TabContent, TabPane } from 'reactstrap';
import { VENDOR_TYPES } from 'pages/Vendor/constants';
import CustomTabs from 'components/CustomTabs';
import IndianFAQ from './components/IndianFAQ';
import ForeignFAQ from './components/ForeignFAQ';

const FAQ = () => {
  const [activeTab, setActiveTab] = useState(VENDOR_TYPES.INDIAN);
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="staff-page appui-faq">
      <Card className="border-0 card-box page-card-box position-relative">
        <CardBody>
          <CustomTabs
            tabs={[VENDOR_TYPES.INDIAN, VENDOR_TYPES.FOREIGN]}
            selectedTab={activeTab}
            onTabChange={toggle}
            className="mb-2"
          />
          <TabContent activeTab={activeTab}>
            {activeTab === VENDOR_TYPES.INDIAN && (
              <TabPane tabId={VENDOR_TYPES.INDIAN}>
                <IndianFAQ />
              </TabPane>
            )}
            {activeTab === VENDOR_TYPES.FOREIGN && (
              <TabPane tabId={VENDOR_TYPES.FOREIGN}>
                <ForeignFAQ />
              </TabPane>
            )}
          </TabContent>
        </CardBody>
      </Card>
    </div>
  );
};

export default FAQ;
